module.exports = __webpack_public_path__ + "static/media/view2.c31151f9.jpg";